export const OPEN_MENU = "header/OPEN_MENU";
export const CLOSE_MENU = "header/CLOSE_MENU";
export const SET_LOGIN_INFO = "header/SET_LOGIN_INFO";
export const SET_LOGO = "header/SET_LOGO";
export const SET_FALSE_TO_IS_TEMP_PASSWORD =
  "header/SET_FALSE_TO_IS_TEMP_PASSWORD";

// Action
export const openMenu = event => ({
  type: OPEN_MENU,
  event
});

export const closeMenu = () => ({
  type: CLOSE_MENU
});

export const setLoginInfo = loginInfo => ({
  type: SET_LOGIN_INFO,
  loginInfo
});

export const setLogo = logo => ({
  type: SET_LOGO,
  logo
});

export const setFalseToIsTempPassword = () => ({
  type: SET_FALSE_TO_IS_TEMP_PASSWORD
});

// Reducer
const initialState = {
  anchorEl: null,
  open: false,
  customerName: "",
  customerLogo: null,
  loginName: "",
  isTempPassword: false
};

const header = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MENU:
      return { ...state, anchorEl: action.event.currentTarget, open: true };
    case CLOSE_MENU:
      return { ...state, open: false };
    case SET_LOGIN_INFO: {
      return { ...state, ...action.loginInfo };
    }
    case SET_LOGO: {
      return { ...state, customerLogo: action.logo };
    }
    case SET_FALSE_TO_IS_TEMP_PASSWORD: {
      return { ...state, isTempPassword: false };
    }
    default:
      return state;
  }
};

export default header;



// WEBPACK FOOTER //
// ./src/redux/modules/header.js